import BaseStepHandler from './handlers/BaseStepHandler';
import TextStepHandler from './handlers/TextStepHandler';
import ImageStepHandler from './handlers/ImageStepHandler';
import MultiTextStepHandler from './handlers/MultiTextStepHandler';
import SignatureStepHandler from './handlers/SignatureStepHandler';
import EffectsStepHandler from './handlers/EffectsStepHandler';
import ColorStepHandler from './handlers/ColorStepHandler';
import SelectStepHandler from './handlers/SelectStepHandler';
import ToggleStepHandler from './handlers/ToggleStepHandler';
import SlabStepHandler from './handlers/SlabStepHandler';
import QRCodeStepHandler from './handlers/QRCodeStepHandler';
import CardNumberStepHandler from './handlers/CardNumberStepHandler';

/**
 * Factory for creating step handler instances
 */
export default class StepHandlerFactory {
    /**
     * Create the appropriate handler for a step
     * 
     * @param {string} stepId - Step ID
     * @param {object} stepDefinition - Step definition from STEPS
     * @param {object} canvas - Canvas instance
     * @param {object} stepManager - StepManager instance
     * @returns {BaseStepHandler} The handler instance
     */
    static createHandler(stepId, stepDefinition, canvas, stepManager, side) {
        // Select the appropriate handler class based on step type
        let HandlerClass;
        
        switch (stepDefinition.type) {
            case 'text':
                HandlerClass = TextStepHandler;
                break;
            case 'image':
                HandlerClass = ImageStepHandler;
                break;
            case 'multi_text':
                HandlerClass = MultiTextStepHandler;
                break;
            case 'signature':
                HandlerClass = SignatureStepHandler;
                break;
            case 'effects':
                HandlerClass = EffectsStepHandler;
                break;
            case 'color':
                HandlerClass = ColorStepHandler;
                break;
            case 'select':
                HandlerClass = SelectStepHandler;
                break;
            case 'slab':
                HandlerClass = SlabStepHandler;
                break;
            case 'toggle':
                HandlerClass = ToggleStepHandler;
                break;
            case 'qrcode':
                HandlerClass = QRCodeStepHandler;
                break;
            case 'card_number': 
                HandlerClass = CardNumberStepHandler;
                break;
            default:
                HandlerClass = BaseStepHandler;
                break;
        }
        
        // Create and initialize the handler
        const handler = new HandlerClass(stepId, stepDefinition, canvas, stepManager, side);
        
        return handler;
    }
}